import { Button, Divider, Flex, ModalBody, ModalFooter, Spinner, Td, Text } from "@chakra-ui/react";
import { Container, Form, Icon, Lottie, Modal, Row, Table } from "components";
import { useUser } from "hooks";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export default function Select(){

    const navigate = useNavigate()
    const user = useUser()

    return(
    <Container>

        <Modal isOpen loading size="lg" onClose={() => navigate('/')}>
            <ModalBody>
                <Flex direction="column" justifyContent="center" alignItems="center">
                    <Lottie animation="warehouse" style={{ width: 120, height: 120, transform: 'scale(1.8)' }} options={{ loop: true }} />
                    <Text fontSize="lg" fontWeight="bold" children="Selecionar centro de distribuição" mt={4} />
                    <Text color="GrayText" children="Por favor, selecione abaixo o distribuidor que deseja acessar" />
                    { user.isLoading && <Spinner mt={4} /> }
                </Flex>

                <Divider my={6} />

                <Table columns={[{}, {}]}>
                    { user.data?.warehouse?.map(item => <Row key={item.id} onClick={() => navigate(`/warehouse/${item.id}`)}><Td fontWeight="bold"><Icon name="distributor" /> {item.name}</Td><Td>{`${item.address_neighborhood} | ${item.city?.name}, ${item.city?.state_code}`}</Td></Row>) }
                </Table>
            </ModalBody>
            <ModalFooter>
                <Button size="sm" w="100%" children="Voltar ao backoffice" leftIcon={<Icon name="left" />} onClick={() => navigate('/')} />
            </ModalFooter>
        </Modal>

    </Container>
    )
}